// Module
var code = "<div class=\"top-menu row\"> <div class=col-sm-12> <nav> <router-link to=/off-chain-tools>Off chain</router-link> <router-link to=/on-chain-tools>On chain</router-link> <router-link to=/node-tools>Node</router-link> </nav> </div> </div> ";
// Exports
module.exports = code;